import { render, staticRenderFns } from "./PublicSwitchRegion.vue?vue&type=template&id=3316de12&"
import script from "./PublicSwitchRegion.vue?vue&type=script&lang=js&"
export * from "./PublicSwitchRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3316de12')) {
      api.createRecord('3316de12', component.options)
    } else {
      api.reload('3316de12', component.options)
    }
    module.hot.accept("./PublicSwitchRegion.vue?vue&type=template&id=3316de12&", function () {
      api.rerender('3316de12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/PublicSwitchRegion.vue"
export default component.exports